import React, { useState, useEffect } from "react";
import Header from "./Header";
import Loader from "./Loader.js";
import GreyArrow from "../assets/greyLeftAr.png";
import FilterIcon from "../assets/filterIcon.png";
import Search from "../assets/search.png";
import Email from "../assets/mailRed.png";
import GuestIcon from "../assets/guestIcon.png";
import { Modal } from "react-bootstrap";
import MsgBox from "../assets/orngMsg.svg";
import OrngMsg from "../assets/orngMsg.svg";
import userIcn from "../assets/person_pin_circle.svg";
import { FaRegEye, FaTimes } from "react-icons/fa";
import DatePicker from "react-datepicker";
import {
  options_search,
  GuestManagementPageText,
} from "./../CommonJquery/WebsiteText";
import {
  server_post_data,
  get_all_contact_data,
  update_guest_vip_status,
  get_all_notes_by_id,
  save_contact_admin,
  save_contact_log,
  APL_LINK,
} from "../ServiceConnection/serviceconnection.js";
import {
  handleError,
  computeTodayDate,
  handleIaphabetnumberChange,
  handleAphabetsChange,
  handleEmailChange,
  handleNumbersChange,
  computeplussevendays,
  mondayDayYearFormat,
  goBack,
  formatToYYYYMMDD,
} from "../CommonJquery/CommonJquery";
import { Button } from "@mui/material";
import { ArrowLeft } from "lucide-react";
import { Eye } from "lucide-react";
import Edit from "../assets/msgbox2.svg";
import { retrieveData } from "../LocalConnection/LocalConnection.js";

function Lead_Managment() {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editStaffData, seteditStaffData] = useState([]);
  // Set initial state using useState hook
  const [startDate, setStartDate] = useState(computeplussevendays());
  const [endDate, setEndDate] = useState(computeTodayDate());
  const [SelectedData, setSelectedData] = useState([]);
  const [searchfilter, setSearchFilter] = useState("");
  const [filteredData, setfilteredData] = useState([]);
  const [flagData, setflagData] = useState("1");
  const [selectedValue, setSelectedValue] = useState("Name"); // State to hold the selected value
  const [noteShow2, setNoteShow2] = useState(false);
  const [SelectedDataDetails, setSelectedDataDetails] = useState([]);
  const [StaffImageLinkData, setsStaffImageLinkData] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [imgname, setimgname] = useState("");
  const [leadStatus, setleadStatus] = useState("NA");
  const [bookingStatus, setbookingStatus] = useState("");
  const [newNotes, setNewNOtes] = useState("");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Set to 10 items per page as requested

  const handleSelect = (event) => {
    setSelectedValue(event.target.value);
  };

  useEffect(() => {
    const flag = "1";
    let call_id = "0";
    master_data_get(startDate, endDate, flag, call_id);
  }, []);

  useEffect(() => {
    // Reset to first page when data changes
    setCurrentPage(1);
  }, [filteredData]);

  const search_data = () => {
    const flag = "2";
    const call_id = "0";
    master_data_get(startDate, endDate, flag, call_id);
  };

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    setflagData(flag);
    fd.append("start_date", formatToYYYYMMDD(start_date));
    fd.append("from_where", 1);
    fd.append("end_date", formatToYYYYMMDD(end_date));
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    fd.append("search_option", selectedValue || "Name");
    fd.append("search_data", searchfilter || "");

    await server_post_data(get_all_contact_data, fd)
      .then((Response) => {
        //console.log("📦 Response from server:", Response.data); // DEBUG LOG

        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setimgname(APL_LINK + Response.data.message.image_link);
          seteditStaffData(Response.data.message.data_subscribe);
          setfilteredData(Response.data.message.data_subscribe);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value;
    setSearchFilter(searchValue);

    // Filter table data based on search value
    const filteredDatashow = editStaffData.filter((row) => {
      return Object.values(row).some((value) => {
        if (value !== null && value !== undefined) {
          // Add null check here
          return (
            typeof value === "string"
              ? value.toLowerCase()
              : value.toString().toLowerCase()
          ).includes(searchValue.toLowerCase());
        }
        return false;
      });
    });

    setfilteredData(filteredDatashow);
  };

  const handleShowModal = (option) => {
    setModalData(option);
    setbookingStatus(option.booking_status);
    setleadStatus(option.action);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSearchFilter("");
    setSelectedValue("Name");
    master_data_get(startDate, endDate, "1", "0"); // Full refresh
  };

  const handleUpdateLead = async (main_id) => {
    //console.log("The Update called for the id", main_id);

    setshowLoaderAdmin(true);

    await updateLeadstatus(main_id);

    if (newNotes !== "") {
      await updateLeadNotes(main_id);
    }

    setNewNOtes("");
    handleCloseModal(); // This handles re-fetch too
    setshowLoaderAdmin(false);
  };

  const updateLeadstatus = async (main_id) => {
    const fd = new FormData();
    fd.append("main_id", main_id);
    fd.append("action", leadStatus);
    fd.append("booking_status", bookingStatus);

    await server_post_data(save_contact_admin, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        }
      })
      .catch((error) => {
        handleError("network");
      });
  };
  const updateLeadNotes = async (main_id) => {
    const name = retrieveData("admin_name");
    const fd = new FormData();
    fd.append("main_id", main_id);
    fd.append("message", newNotes);
    fd.append("booking_status", bookingStatus);
    fd.append("name", name);

    await server_post_data(save_contact_log, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        }
      })
      .catch((error) => {
        handleError("network");
      });
  };

  const handleViewClick = (event, drivingimg) => {
    event.stopPropagation(); // Prevent triggering file upload click
    if (drivingimg) {
      const newTab = window.open();
      newTab.document.write(
        `<img src="${drivingimg}" style="max-width:50%; height:auto;" />`
      );
      newTab.document.title = "Uploaded Image";
    } else {
      const newTab = window.open();
      newTab.document.write(
        `<img src="${drivingimg}" style="max-width:50%; height:auto;" />`
      );
      newTab.document.title = "Uploaded Image";
    }
  };

  const handleDateChange = (date) => {
    setStartDate(date);
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems =
    filteredData && filteredData?.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  console.log(currentItems);
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    return buttons;
  };

  const notesData = [
    {
      date: "20/05/2025",
      message:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      date: "21/05/2025",
      message: "Customer requested a callback next week.",
    },
    {
      date: "22/05/2025",
      message: "Updated booking status to 'In Process'.",
    },
    {
      date: "23/05/2025",
      message: "Lead converted successfully. Payment pending.",
    },
  ];

  const downloadLeadsAsCSV = () => {
    const headers = [
      "Sr.No.",
      "Entry Date",
      "Name",
      "Email",
      "Phone",
      "Pickup Date",
      "Driving Licence",
      "Source",
      "Lead Status",
      "Booking Status",
    ];
    const dataToExport = filteredData.length > 0 ? filteredData : editStaffData;
    const rows = dataToExport.map((item, index) => [
      index + 1,
      mondayDayYearFormat(item.entry_date),
      item.name || "NA",
      item.email || "NA",
      item.phone || "NA",
      mondayDayYearFormat(item.from_date),
      item.dropdown ? "Available" : "NA",
      item.source || "NA",
      item.action === "null" || !item.action ? "No Action" : item.action,
      item.booking_status === "Yes" ? "Booked" : "Not Booked",
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...rows.map((row) => row.join(","))].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "Leads.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}

      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <Header />
            <div className="pageCntn_head">
              <div className="pageNameDiv">
                <p className="breadcrumb-item">Lead Management</p>
                <img src={GreyArrow} alt="Rapid Car Leasing" />
              </div>
              <div className={` alignCol bottomAlgin col-xl-3 mb-0`}>
                <div className="pageActionBtns">
                  <button
                    className="CSVBTN"
                    style={{ height: "38px" }}
                    onClick={downloadLeadsAsCSV}
                  >
                    Download Excel
                  </button>
                </div>
              </div>
              <Button
                onClick={goBack}
                startIcon={
                  <ArrowLeft size={17} style={{ marginBottom: "2px" }} />
                }
                className="Back_bttn_page"
              >
                Back
              </Button>
            </div>

            <div className="page_body">
              <div className="viewStaff">
                <div className="viewStaff_head">
                  <div className="row m-0">
                    <div className="col-lg-2 col-sm-4 bottomAlgin">
                      <label className="labelView">
                        {GuestManagementPageText.Start_Date}
                      </label>
                      <div className="person__calenderFrame_image image_icon_position1 ">
                        <DatePicker
                          selected={startDate}
                          onChange={handleDateChange}
                          className="form-control input_field_custom4"
                          maxDate={computeTodayDate()}
                          dateFormat="MM-dd-yyyy"
                          placeholderText="MM-DD-YYYY"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-4 bottomAlgin">
                      <label className="labelView">
                        {GuestManagementPageText.End_Date}
                      </label>
                      <div className="person__calenderFrame_image image_icon_position1 ">
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          className="form-control input_field_custom4"
                          maxDate={computeTodayDate()}
                          minDate={startDate}
                          dateFormat="MM-dd-yyyy"
                          placeholderText="MM-DD-YYYY"
                        />
                      </div>
                    </div>
                    <div className="col-lg-1 col-sm-2 bottomAlgin">
                      <div
                        className="inputDiv2"
                        style={{ backgroundColor: "transparent", padding: "0" }}
                      >
                        <button
                          type="button"
                          className="btnSearch"
                          onClick={() => search_data()}
                        >
                          {GuestManagementPageText.Search_text}
                        </button>
                      </div>
                    </div>

                    <div
                      className="col-xl-3 col-md-4 bottomAlgin"
                      style={{ marginLeft: "auto", marginRight: "0" }}
                    >
                      <div className="inputDiv2">
                        <label className="labelPointer" htmlFor="selectFilter">
                          <img src={FilterIcon} alt="Rapid Car Leasing" />
                        </label>
                        <input
                          type="text"
                          placeholder={GuestManagementPageText.Guest_Filter}
                          value={searchfilter}
                          onInput={handleIaphabetnumberChange}
                          onChange={handleSearch}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ padding: "0 10px" }}>
                  <div className="cust_hist_card" style={{ padding: "0 10px" }}>
                    <div className="reservationHistoryTable">
                      <div
                        className="historyTableContainer stickyTableheigh274"
                        style={{ overflowX: "auto" }}
                      >
                        <table className="table margin_class_table">
                          <thead className="stickyHeaderClss">
                            <tr>
                              <th scope="col">Sr.No.</th>
                              <th scope="col"> Entry Date</th>
                              <th scope="col">
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    src={GuestIcon}
                                    alt="Rapid Car Leasing"
                                    style={{ height: "20px", width: "20px" }}
                                  />
                                  <span className="fontWeight600">
                                    Driver Details
                                  </span>
                                </div>
                              </th>
                              {/* <th scope="col">
                                {" "}
                                {GuestManagementPageText.Email_ID}
                              </th> */}
                              <th scope="col"> Pickup Date</th>
                              <th scope="col"> Driving Licence</th>
                              {/* <th scope="col"> Source</th> */}
                              <th scope="col"> Lead Status</th>
                              <th scope="col">Booking Status</th>
                              <th scope="col">Actions</th>
                            </tr>
                          </thead>
                          <tbody className="custum_border">
                            {currentItems && currentItems.length > 0 ? (
                              currentItems.map((option, index) => (
                                <tr
                                  className="historyTableRow h-auto"
                                  key={index}
                                  style={{ fontSize: "13px" }}
                                >
                                  <td>
                                    <div
                                      className="historyTableRowText height50 historyName justify-content-start"
                                      style={{
                                        marginLeft: "20px",
                                      }}
                                    >
                                      {indexOfFirstItem + index + 1}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText height50 historyName justify-content-start">
                                      {mondayDayYearFormat(option.entry_date)}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText height50 historyName justify-content-start">
                                      {option.name}
                                      <br />
                                      {option.email}
                                      <br />
                                      {option.phone}
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      className="historyTableRowText height50 historyPerson justify-content-start"
                                      style={{ flexWrap: "wrap" }}
                                    >
                                      {mondayDayYearFormat(option.from_date)}
                                    </div>
                                  </td>
                                  <td>
                                    {option.dropdown == "" ? (
                                      <div
                                        className="historyTableRowText height50 text-center historyPerson justify-content-start"
                                        style={{ flexWrap: "wrap" }}
                                      >
                                        NA
                                      </div>
                                    ) : (
                                      <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                                        <span
                                          style={{
                                            cursor: "pointer",
                                            marginTop: "12px",
                                            // marginRight: "65px",
                                          }}
                                          onClick={(e) =>
                                            handleViewClick(
                                              e,
                                              imgname + option.dropdown
                                            )
                                          }
                                        >
                                          <Eye
                                            size={18}
                                            className="icon_imgGG"
                                            style={{
                                              cursor: "pointer",
                                              color: "var(--primary-color)",
                                              marginTop: "5px",
                                            }}
                                            strokeWidth={1.5}
                                          />
                                        </span>
                                      </div>
                                    )}
                                  </td>
                                  {/* <td>
                                    <div
                                      className="historyTableRowText height50 historyPerson justify-content-start"
                                      style={{ flexWrap: "wrap" }}
                                    >
                                      {option?.source || "NA"}
                                    </div>
                                  </td> */}
                                  <td>
                                    <div
                                      className="historyTableRowText height50 historyPerson justify-content-start"
                                      style={{ flexWrap: "wrap" }}
                                    >
                                      <span
                                        className={`status-new2 ${
                                          option.action === "Called"
                                            ? "status-called"
                                            : option.action === "Not Reachable"
                                            ? "status-not-reachable"
                                            : option.action === "In Process"
                                            ? "status-in-process"
                                            : option.action === "Converted"
                                            ? "status-converted"
                                            : ""
                                        }`}
                                      >
                                        {option?.action &&
                                        option.action != "null"
                                          ? option.action
                                          : "No Action"}
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      className="historyTableRowText height50 historyPerson justify-content-start"
                                      style={{ flexWrap: "wrap" }}
                                    >
                                      {option.booking_status === "Yes" ? (
                                        <span className="status-new2 status-converted">
                                          Booked
                                        </span>
                                      ) : (
                                        <span className="status-new2 status-not-reachable">
                                          Not Booked
                                        </span>
                                      )}
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      className="historyTableRowText height50 historyPerson justify-content-start"
                                      style={{ flexWrap: "wrap" }}
                                    >
                                      <div className="recentReservBtns">
                                        <button
                                          style={{
                                            width: "fit-content",
                                            backgroundColor: "#ffffff",
                                          }}
                                          onClick={() =>
                                            handleShowModal(option)
                                          }
                                        >
                                          <p>Update Status</p>
                                          <img
                                            style={{
                                              width: "18px",
                                              height: "18px",
                                            }}
                                            src={Edit}
                                            alt="Rapid Car Leasing"
                                          />
                                        </button>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={6} className="text_align_center">
                                  No Results Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        {/* Pagination Footer */}
                        <div className="cust_hist_card_footer">
                          <div className="cust_hist_pagination_info">
                            {filteredData.length > 0 ? (
                              <>
                                Showing{" "}
                                <span className="cust_hist_pagination_bold">
                                  {indexOfFirstItem + 1}
                                </span>{" "}
                                to{" "}
                                <span className="cust_hist_pagination_bold">
                                  {Math.min(
                                    indexOfLastItem,
                                    filteredData.length
                                  )}
                                </span>{" "}
                                of{" "}
                                <span className="cust_hist_pagination_bold">
                                  {filteredData.length}
                                </span>{" "}
                                Leads
                              </>
                            ) : (
                              <>
                                Showing{" "}
                                <span className="cust_hist_pagination_bold">
                                  0
                                </span>{" "}
                                guests
                              </>
                            )}
                          </div>
                          <div className="cust_hist_pagination">
                            <nav aria-label="Pagination">
                              <ul className="cust_hist_pagination_list">
                                {renderPaginationButtons()}
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ------testimonial message Modal------------ */}
      <Modal
        className="testMsgModal newRadiusC"
        show={showModal}
        onHide={handleCloseModal}
        size="md"
        centered
      >
        <Modal.Body>
          <div className="closeBtn" onClick={handleCloseModal}>
            <FaTimes className="closeIcn" />
          </div>
          <div className="testiModalMsg">
            <div className="detailsHeadNew">
              <div>
                <h5 className="mb-1">{modalData?.name}</h5>
                <div>
                  <h6 className="mb-1" style={{ fontSize: "14px" }}>
                    {modalData?.email}, {modalData?.phone}
                  </h6>
                  <h6 style={{ fontSize: "14px" }}>
                    Pickup Date: {mondayDayYearFormat(modalData?.from_date)}
                  </h6>
                </div>
              </div>
              <div>
                <h6 style={{ fontSize: "14px" }}>
                  Lead Date: {mondayDayYearFormat(modalData?.entry_date)}
                </h6>
              </div>
            </div>
            <div className="statusUpdateOptions">
              <div className="historyTableRowText historyPerson d-flex justify-content-start align-items-center gap-4">
                <div style={{ width: "fit-content" }}>
                  <label className="labelView">Lead Status</label>
                  <select
                    defaultValue={modalData?.action ?? ""}
                    onChange={(e) => setleadStatus(e.target.value)}
                    className="NEWseLECTiNPUTlEAD"
                    disabled={modalData?.action === "Converted"}
                  >
                    <option value="" disabled hidden>
                      Select status
                    </option>
                    <option value="Called">Called</option>
                    <option value="Not Reachable">Not Reachable</option>
                    <option value="In Process">In Process</option>
                    <option value="Converted">Converted</option>
                  </select>
                </div>
                {leadStatus === "Converted" && (
                  <div style={{ width: "fit-content" }}>
                    <label className="labelView">Booking Status</label>
                    <select
                      defaultValue={bookingStatus}
                      onChange={(e) => setbookingStatus(e.target.value)}
                      className="NEWseLECTiNPUTlEAD"
                    >
                      <option value="" disabled hidden>
                        Select status
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                )}
              </div>
            </div>
            <div className="COMMUNICATONLOGS">
              <p className="notesHEdaer">Remarks & Notes</p>
              <div className="notesContainer">
                {modalData?.logs?.map((note, index) => (
                  <div className="notesITems" key={index}>
                    <div className="d-flex align-items-center gap-1">
                      <img style={{ width: "14px" }} src={Edit} alt="Msg Box" />
                      <span style={{ fontSize: "11px" }}>
                        Date: {new Date(note.entry_date).toLocaleDateString()}
                      </span>
                    </div>
                    <p className="msgNotes">{note.message}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="actionsModalBtns">
              <textarea
                defaultValue={newNotes}
                onChange={(e) => setNewNOtes(e.target.value)}
                placeholder="Add notes here..."
              ></textarea>
              <div className="btnasss">
                <button
                  className="btn btn-primary classicBtn"
                  onClick={() => {
                    handleUpdateLead(modalData.primary_id);
                  }}
                >
                  Save
                </button>
                <button
                  className="btn btn-secondary classicBtn"
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Lead_Managment;
